module.exports = __webpack_public_path__ + "static/media/facebook_inverted_hover.acd46fbe.svg";